import { render, staticRenderFns } from "./diagnosesInformation.vue?vue&type=template&id=fa300a9e&"
import script from "./diagnosesInformation.vue?vue&type=script&lang=js&"
export * from "./diagnosesInformation.vue?vue&type=script&lang=js&"
import style0 from "./diagnosesInformation.vue?vue&type=style&index=0&id=fa300a9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports